// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container{
    border: 1px solid lightgrey;
    border-radius: 7px !important;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

/* .main-container h1{
    font-family: auto;
    font-weight: bolder;
    font-size: 50px;
    margin-top: 35px;
}

.main-container p{
    font-size: 20px;
    font-weight: 500;
    margin-top: 50px;
}

.main-container h2{
    font-style: italic;
    font-family: auto;
    font-weight: bolder;
    font-size: 40px;
    margin-top: 50px;
    border-bottom: 1px solid black;
}

.main-container span{
    margin-top: 10px;
    font-size: 17px;
    font-weight: 500;
    display: flex;
    align-items: end;
    justify-content: center;
    gap: 11px;
} */


.badge-box-sm {
    background: mediumpurple;
    width: 4.0em;
    height: 4.0em;
    border-radius: 20%;
    display: inline-block;
    transition: all 0.2s ease;
    box-shadow: 8px 10px 12px 3px rgba(0, 0, 0, 0.2);
    position: relative;
  }
  
  .badge-box-sm .badge-rounded-sm {
    width: 40px;
    height: 40px;
    background: white;
    position: absolute;
    margin: 12px 5px auto;
    z-index: 10;
    border-radius: 22%;
    box-shadow: 8px 8px 8px 2px rgba(0, 0, 0, 0.23);
  }

.loader {
    color: #9a80fb;
    font-size: 36px;
    text-indent: -9999em;
    overflow: hidden;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    margin: 0 auto;
    position: fixed;
    left: 0;
    right: 0;
    z-index: 99;
    top: 50%;
    transform: translateZ(0);
    animation: load6 1.7s infinite ease, round 1.7s infinite ease;
}

.loadwapper {
    background: rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    justify-items: center;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
}


.btnDownload{
    background: #6c2fbb;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 9px;
}

::ng-deep mat-dialog-container#mat-dialog-0{
    padding: 32px 30px 0;
    overflow: auto;
    height: 100vh;
}

@media (max-width: 1199px) {
    .main-container >div >div:last-child {
        padding: 0 80px !important;
    }
    .main-container h2 {
        width: 500px !important;
    }
}
@media (max-width: 991px) {
    .main-container >div >div:last-child {
        padding: 0 42px !important;
    }
    .main-container h2 {
        width: 400px !important;
    }
}
@media (max-width: 767px) {
    .main-container h2 {
        width: 300px !important;
    }
    .main-container >div >div:last-child {
        flex-direction: column;
    }
    .main-container h1 {
        font-size: 30px !important;
        margin-top: 10px !important;
    }
    .main-container >div >p {
        margin: 0 !important;
    }
}
@media (max-width: 575px) {
    .main-container h1 {
        font-size: 27px !important;
        margin-top: 0 !important;
    }
    .main-container h2 {
        font-size: 20px !important;
        width: auto !important;
    }
    .main-container >div >p {
        font-size: 20px !important;
        margin-top: 7px !important;
    }
    .main-container >div >div:last-child {
        padding: 0 !important;
    }
    ::ng-deep mat-dialog-container{
        padding: 10px !important;
        height: calc(100vh - 100px) !important;
    }
    ::ng-deep .cdk-overlay-pane {
        max-width: 90vw !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/main-certificates/main-certificates.component.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8BG;;;AAGH;IACI,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,gDAAgD;IAChD,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,+CAA+C;EACjD;;AAEF;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,OAAO;IACP,QAAQ;IACR,WAAW;IACX,QAAQ;IAGR,wBAAwB;IAExB,6DAA6D;AACjE;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,MAAM;IACN,OAAO;AACX;;;AAGA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;IACA;QACI,oBAAoB;IACxB;AACJ;AACA;IACI;QACI,0BAA0B;QAC1B,wBAAwB;IAC5B;IACA;QACI,0BAA0B;QAC1B,sBAAsB;IAC1B;IACA;QACI,0BAA0B;QAC1B,0BAA0B;IAC9B;IACA;QACI,qBAAqB;IACzB;IACA;QACI,wBAAwB;QACxB,sCAAsC;IAC1C;IACA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".main-container{\n    border: 1px solid lightgrey;\n    border-radius: 7px !important;\n    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n}\n\n/* .main-container h1{\n    font-family: auto;\n    font-weight: bolder;\n    font-size: 50px;\n    margin-top: 35px;\n}\n\n.main-container p{\n    font-size: 20px;\n    font-weight: 500;\n    margin-top: 50px;\n}\n\n.main-container h2{\n    font-style: italic;\n    font-family: auto;\n    font-weight: bolder;\n    font-size: 40px;\n    margin-top: 50px;\n    border-bottom: 1px solid black;\n}\n\n.main-container span{\n    margin-top: 10px;\n    font-size: 17px;\n    font-weight: 500;\n    display: flex;\n    align-items: end;\n    justify-content: center;\n    gap: 11px;\n} */\n\n\n.badge-box-sm {\n    background: mediumpurple;\n    width: 4.0em;\n    height: 4.0em;\n    border-radius: 20%;\n    display: inline-block;\n    transition: all 0.2s ease;\n    box-shadow: 8px 10px 12px 3px rgba(0, 0, 0, 0.2);\n    position: relative;\n  }\n  \n  .badge-box-sm .badge-rounded-sm {\n    width: 40px;\n    height: 40px;\n    background: white;\n    position: absolute;\n    margin: 12px 5px auto;\n    z-index: 10;\n    border-radius: 22%;\n    box-shadow: 8px 8px 8px 2px rgba(0, 0, 0, 0.23);\n  }\n\n.loader {\n    color: #9a80fb;\n    font-size: 36px;\n    text-indent: -9999em;\n    overflow: hidden;\n    width: 1em;\n    height: 1em;\n    border-radius: 50%;\n    margin: 0 auto;\n    position: fixed;\n    left: 0;\n    right: 0;\n    z-index: 99;\n    top: 50%;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-animation: load6 1.7s infinite ease, round 1.7s infinite ease;\n    animation: load6 1.7s infinite ease, round 1.7s infinite ease;\n}\n\n.loadwapper {\n    background: rgba(0, 0, 0, 0.05);\n    display: flex;\n    align-items: center;\n    justify-items: center;\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    z-index: 9999;\n    top: 0;\n    left: 0;\n}\n\n\n.btnDownload{\n    background: #6c2fbb;\n    font-weight: 600;\n    font-size: 16px;\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    gap: 9px;\n}\n\n::ng-deep mat-dialog-container#mat-dialog-0{\n    padding: 32px 30px 0;\n    overflow: auto;\n    height: 100vh;\n}\n\n@media (max-width: 1199px) {\n    .main-container >div >div:last-child {\n        padding: 0 80px !important;\n    }\n    .main-container h2 {\n        width: 500px !important;\n    }\n}\n@media (max-width: 991px) {\n    .main-container >div >div:last-child {\n        padding: 0 42px !important;\n    }\n    .main-container h2 {\n        width: 400px !important;\n    }\n}\n@media (max-width: 767px) {\n    .main-container h2 {\n        width: 300px !important;\n    }\n    .main-container >div >div:last-child {\n        flex-direction: column;\n    }\n    .main-container h1 {\n        font-size: 30px !important;\n        margin-top: 10px !important;\n    }\n    .main-container >div >p {\n        margin: 0 !important;\n    }\n}\n@media (max-width: 575px) {\n    .main-container h1 {\n        font-size: 27px !important;\n        margin-top: 0 !important;\n    }\n    .main-container h2 {\n        font-size: 20px !important;\n        width: auto !important;\n    }\n    .main-container >div >p {\n        font-size: 20px !important;\n        margin-top: 7px !important;\n    }\n    .main-container >div >div:last-child {\n        padding: 0 !important;\n    }\n    ::ng-deep mat-dialog-container{\n        padding: 10px !important;\n        height: calc(100vh - 100px) !important;\n    }\n    ::ng-deep .cdk-overlay-pane {\n        max-width: 90vw !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
